import React from 'react';
import { useNavigate } from 'react-router';

import { StepProps } from '@/widgets/ServiceFormTemplate';

import { StepControlPanel } from '@/shared/ui';

import { Result } from '@/components/Forms/Steps/Result';

import { ROUTES } from '@/router/config';

export const ExtractRedeliveryResult: React.FC<StepProps> = ({ serviceCode }) => {
  const navigate = useNavigate();

  return (
    <>
      <Result variant="new" serviceCode={serviceCode} />

      <StepControlPanel
        next={() => navigate(ROUTES.USER.REQUESTS.ACTIVE_REQUESTS)}
        nextBtnText="Мої запити"
        withArrow={false}
      />
    </>
  );
};
